"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.productFacetAllowedList = exports.productSearchQueryAllowedList = exports.searchQueryListToLocalise = void 0;
const index_1 = require("./index");
const algoliaAttributes_1 = require("./algoliaAttributes");
const searchQueryListNotLocalised = [
    algoliaAttributes_1.ALGOLIA_ATTRIBUTES.CATEGORIES_KEY,
    algoliaAttributes_1.ALGOLIA_ATTRIBUTES.SIZE,
    algoliaAttributes_1.ALGOLIA_ATTRIBUTES.PRICE_CENT_AMOUNT,
];
exports.searchQueryListToLocalise = [
    algoliaAttributes_1.ALGOLIA_ATTRIBUTES.PRODUCT_TYPE,
    algoliaAttributes_1.ALGOLIA_ATTRIBUTES.PRODUCT_SUB_TYPES,
    algoliaAttributes_1.ALGOLIA_ATTRIBUTES.CATEGORIES_NAME,
    algoliaAttributes_1.ALGOLIA_ATTRIBUTES.COLOR,
    algoliaAttributes_1.ALGOLIA_ATTRIBUTES.BRAND,
    algoliaAttributes_1.ALGOLIA_ATTRIBUTES.TECHNOLOGIES,
    algoliaAttributes_1.ALGOLIA_ATTRIBUTES.SUB_TECHNOLOGIES,
    algoliaAttributes_1.ALGOLIA_ATTRIBUTES.FASTENING,
    algoliaAttributes_1.ALGOLIA_ATTRIBUTES.STYLE_NAME,
    algoliaAttributes_1.ALGOLIA_ATTRIBUTES.UPPER_MATERIAL,
    algoliaAttributes_1.ALGOLIA_ATTRIBUTES.GENDER,
    algoliaAttributes_1.ALGOLIA_ATTRIBUTES.REVIEW_RATING,
    algoliaAttributes_1.ALGOLIA_ATTRIBUTES.HEEL_HEIGHT_GROUPS,
    algoliaAttributes_1.ALGOLIA_ATTRIBUTES.FIT,
];
const productSearchQueryAllowedList = (stores) => {
    return [
        ...searchQueryListNotLocalised,
        ...exports.searchQueryListToLocalise.flatMap((property) => [
            ...stores.flatMap((store) => [...(0, index_1.localiseProperty)(property, store)]),
        ]),
    ];
};
exports.productSearchQueryAllowedList = productSearchQueryAllowedList;
const productFacetAllowedList = (stores) => {
    return [
        algoliaAttributes_1.ALGOLIA_ATTRIBUTES.SIZE,
        algoliaAttributes_1.ALGOLIA_ATTRIBUTES.PRICE_CENT_AMOUNT,
        ...exports.searchQueryListToLocalise.flatMap((property) => [
            ...stores.flatMap((store) => [...(0, index_1.localiseProperty)(property, store)]),
        ]),
    ];
};
exports.productFacetAllowedList = productFacetAllowedList;
//# sourceMappingURL=productSearchQueryAllowedList.js.map